module.exports = __webpack_public_path__ + "img/demonic_statue_small.aa96de20.png";